import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { I18nProvider } from "./lib/i18n";
import { ThemeProvider } from "./lib/theme";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import ProjectIDE from "./pages/ProjectIDE";
import Showcase from "./pages/Showcase";
import { Toaster } from "sonner";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen gc-app text-sm" style={{ color: "var(--gc-muted)" }}>
        <span className="gf-blink">CHECKING SESSION...</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  // Synchronous detection during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return null;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/project/:projectId"
        element={
          <ProtectedRoute>
            <ProjectIDE />
          </ProtectedRoute>
        }
      />
      <Route path="/showcase/:slug" element={<Showcase />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App gc-app">
      <ThemeProvider>
        <I18nProvider>
          <AuthProvider>
            <BrowserRouter>
              <AppRouter />
              <Toaster position="bottom-right" />
            </BrowserRouter>
          </AuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;